<template>
    <div class="main">
        <h2>订单查询</h2>
        <v-form style="width: 100%; margin-top: 40px;"
                label-width="6em"
                :model="form"
        >
            <v-form-item label="订单号">
                <input class="form-control" type="text" v-model="form.id">
            </v-form-item>
            <v-form-item label="联系人手机">
                <input class="form-control" type="text" v-model="form.customerPhone">
            </v-form-item>
        </v-form>
        <v-form style="width: 100%; margin-top: 30px;"
                label-width="6em"
                :model="form"
        >
            <v-form-item label="产品编号">
                <input class="form-control" type="text" v-model="form.productNo">
            </v-form-item>
            <v-form-item label="产品关键字">
                <input class="form-control" type="text" v-model="form.productName">
            </v-form-item>
            <v-button type="primary" @click="searchOrder">搜索</v-button>
        </v-form>
        <h2>查询结果<v-button type="primary" @click="exportExcel">导出订单</v-button></h2>
        <v-table style="width: 100%; background-color: #FFF; margin-top: 20px;"
                 :data="tableData"
                 :column="tableColumn"
                 v-loading="isLoading"
        >
            <template slot="productInfo" scope="props">
                <div>产品名称：{{ props.data.productName }}</div>
                <div>产品编号：{{ props.data.productNo }}</div>
                <div>货号：{{ props.data.goodsNo }}</div>
            </template>
            <template slot="customerInfo" scope="props">
                <div>{{ props.data.customerName }}</div>
                <div>{{ props.data.customerPhone }}</div>
                <div>{{ props.data.customerAddress }}</div>
            </template>
            <template slot="action" scope="props">
                <div class="allow-btn" @click="sendProduct(props.data)">发货</div>
                <div class="refuse-btn" @click="reject(props.data)">放弃</div>
            </template>
        </v-table>
        <v-pagination
            :current='currentPage'
            :total='Math.ceil(totalCount / 20)'
            :size="'md'"
            :first="false"
            :last="false"
            v-on:current-change="currentChangeFunc($event)"
            style="text-align: right;"
        ></v-pagination>
        <v-dialog v-model="sendProductDialog" title="订单信息" :modalAppendToBody="false">
            <ul>
                <li>
                    <label>订单号：</label>
                    <p>{{ sendProductInfo.id }}</p>
                </li>
                <li>
                    <label>产品名称：</label>
                    <p>{{ sendProductInfo.productName }}</p>
                </li>
                <li>
                    <label>产品编号：</label>
                    <p>{{ sendProductInfo.productNo }}</p>
                </li>
                <li>
                    <label>货号：</label>
                    <p>{{ sendProductInfo.id }}</p>
                </li>
                <li>
                    <label>下单时间：</label>
                    <p>{{ sendProductInfo.orderCreateTime }}</p>
                </li>
                <li>
                    <label>总价：</label>
                    <p>{{ sendProductInfo.totalPrice }}</p>
                </li>
                <li>
                    <label>联系人信息：</label>
                    <p>{{ sendProductInfo.customerName + ' ' + sendProductInfo.customerPhone + ' ' + sendProductInfo.customerAddress }}</p>
                </li>
                <li>
                    <label>快递公司：</label>
                    <v-select v-model="deliver.deliverCode" placeholder="请选择" filterable>
                        <v-option v-for="item in expressInfo" :label="item.name" :value="item.code" :key="item.code"></v-option>
                    </v-select>
                </li>
                <li>
                    <label>快递单号：</label>
                    <input type="text" class="form-control" v-model="deliver.deliverNo">
                </li>
            </ul>
            <div slot="footer" class="dialog-footer">
                <button class="btn btn-default" @click="cancelSendProduct">取消</button>
                <button class="btn btn-warning" @click="submitSendProduct">确认发货</button>
            </div>
        </v-dialog>
        <v-dialog v-model="rejectDialog" title="放弃" :modalAppendToBody="false">
            <ul>
                <li>
                    <label>放弃理由：</label>
                    <v-select v-model="rejectInfo.reason" placeholder="请选择">
                        <v-option v-for="(item, key) in REJECT_REASON" :label="item" :value="key" :key="key"></v-option>
                    </v-select>
                </li>
                <li>
                    <label>描述：</label>
                    <input type="text" class="form-control" v-model="rejectInfo.describe">
                </li>
            </ul>
            <div slot="footer" class="dialog-footer">
                <button class="btn btn-default" @click="cancelReject">取消</button>
                <button class="btn btn-warning" @click="submitReject">确认放弃</button>
            </div>
        </v-dialog>
    </div>
</template>

<style lang="scss" scoped="scoped">
    .main {
        min-height: 100%;
        background-color: #F7F9FA;
        padding: 20px 15px;
        > h2 {
            font-size: 24px;
            &:nth-of-type(n+2) {
                margin-top: 60px;
            }
            > .btn {
                float: right;
            }
        }
        .form-horizontal {
            display: flex;
            .v-form-item {
                width: 20%;
                margin-bottom: 0;
                &:nth-child(n+2) {
                    margin-left: 5%;
                }
                .form-control {
                    width: 100%;
                    display: inline-block;
                }
            }
            .btn-primary {
                margin-left: 30px;
                width: 120px;
            }
        }
        .xigua-modal-dialog {
            ul {
                list-style: none;
                padding: 0;
                li {
                    line-height: 40px;
                    &:nth-child(n+2) {
                        margin-top: 5px;
                    }
                    label {
                        vertical-align: top;
                        height: 100%;
                        margin: 0;
                        width: 100px;
                        font-weight: bold;
                        text-align: right;
                    }
                    p {
                        display: inline-block;
                        vertical-align: top;
                        width: 60%;
                        margin: 0 0 0 10px;
                        overflow: hidden;
                        word-wrap: break-word;
                    }
                    .el-select {
                        display: inline-block;
                        width: 250px;
                    }
                    .form-control {
                        display: inline-block;
                        width: 250px;
                    }
                }
            }
        }
        .refuse-btn {
            width: 50%;
            background-color: #DE290C;
            color: #FFF;
            padding: 5px 0;
            border-radius: 3px;
            display: inline-block;
            margin-top:5px;
        }
        .allow-btn {
            width: 50%;
            background-color: #3dc6b6;
            color: #FFF;
            padding: 5px 0;
            border-radius: 3px;
            display: inline-block;
            margin-top:5px;
        }
    }
</style>

<script>
    import Api from 'api/wenchuang'
    import Moment from 'moment'
    import { REJECT_REASON } from '../constant.js'

    export default {
        data () {
            return {
                form: {
                    id: '',
                    customerPhone: '',
                    productNo: '',
                    productName: ''
                },
                orderState: 1, // 待发货订单
                currentPage: 1,
                totalCount: 0,
                tableData: [],
                tableColumn: [
                    {
                        key: 'id',
                        name: '订单号'
                    },
                    {
                        key: 'productInfo',
                        name: '产品名称',
                        type: 'slot',
                        slot: 'productInfo'
                    },
                    {
                        key: 'totalPrice',
                        name: '总价'
                    },
                    {
                        key: 'refundGoodsInfo',
                        name: '商家信息'
                    },
                    {
                        key: 'orderCreateTime',
                        name: '下单时间'
                    },
                    {
                        key: 'customerInfo',
                        name: '联系人信息',
                        type: 'slot',
                        slot: 'customerInfo'
                    },
                    {
                        key: 'extInfo',
                        name: '备注'
                    },
                    {
                        key: 'action',
                        name: '操作',
                        type: 'slot',
                        slot: 'action'
                    }
                ],
                sendProductDialog: false, // 发货弹层
                sendProductInfo: { // 发货信息
                    id: '',
                    productName: '',
                    productNo: '',
                    orderCreateTime: '',
                    totalPrice: '',
                    customerName: '',
                    customerPhone: '',
                    customerAddress: ''
                },
                expressInfo: [], // 所有快递公司信息
                deliver: {
                    deliverCode: '', // 快递公司编号
                    deliverNo: '' // 快递单号
                },
                REJECT_REASON: REJECT_REASON, //放弃理由
                rejectDialog: false, // 放弃弹层
                rejectInfo: {
                    id: '',
                    reason: '',
                    describe: ''
                },
                isLoading: false
            }
        },
        methods: {

            // 获取订单数据
            getTableData () {
                this.isLoading = true;
                Api.getOrderListData(this.orderState, this.form, this.currentPage)
                    .then((res) => {
                        console.log(res);
                        if (res.status === 0) {
                            let data = res.data;
                            let tableData = [];
                            data.forEach((item) => {
                                tableData.push({
                                    id: item.id,
                                    productInfo: {
                                        productName: item.productName,
                                        productNo: item.productNo,
                                        goodsNo: item.goodsNo
                                    },
                                    totalPrice: item.totalPrice,
                                    refundGoodsInfo: item.refundGoodsInfo,
                                    orderCreateTime: Moment(item.orderCreateTime).format('YYYY-MM-DD HH:mm:ss'),
                                    customerInfo: {
                                        customerName: item.customerName,
                                        customerPhone: item.customerPhone,
                                        customerAddress: item.customerAddress
                                    },
                                    extInfo: item.extInfo,
                                    action: {
                                        id: item.id,
                                        productName: item.productName,
                                        productNo: item.productNo,
                                        orderCreateTime: Moment(item.orderCreateTime).format('YYYY-MM-DD HH:mm:ss'),
                                        totalPrice: item.totalPrice,
                                        customerName: item.customerName,
                                        customerPhone: item.customerPhone,
                                        customerAddress: item.customerAddress
                                    }
                                })
                            })
                            this.tableData = tableData;
                            this.totalCount = res.paging.count;
                        } else {
                            this.$notify.error({
                                title: '错误',
                                message: res.message || '请求失败'
                            })
                        }
                        this.isLoading = false;
                    })
                    .catch((err) => {
                        console.log(err);
                        this.isLoading = false;
                    })
            },

            // 获取快递公司信息
            getExpressInfo () {
                Api.getExpressInfo()
                    .then((res) => {
                        console.log(res);
                        if (res.status === 0) {
                            this.expressInfo = res.data;
                        } else {
                            this.$notify.error({
                                title: '错误',
                                message: res.message || '请求失败'
                            })
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            },

            // 显示发货弹层
            sendProduct (data) {
                this.sendProductInfo = {
                    id: data.id,
                    productName: data.productName,
                    productNo: data.productNo,
                    orderCreateTime: data.orderCreateTime,
                    totalPrice: data.totalPrice,
                    customerName: data.customerName,
                    customerPhone: data.customerPhone,
                    customerAddress: data.customerAddress
                }
                this.sendProductDialog = true;
            },

            // 取消发货
            cancelSendProduct () {
                this.sendProductDialog = false;
            },

            // 确定发货
            submitSendProduct () {
                if (this.deliver.deliverCode === '' || this.deliver.deliverNo.trim() === '') {
                    this.$message({
                        message: '请填写快递公司和快递单号',
                        type: 'error'
                    });
                    return;
                }
                Api.sendProduct(this.sendProductInfo.id, this.deliver.deliverCode, this.deliver.deliverNo)
                    .then((res) => {
                        console.log(res);
                        if (res.status === 0) {
                            this.sendProductDialog = false;
                            this.$alert({
                                title: '提示',
                                message: '发货成功',
                                showCancelButton: false,
                                closeOnClickModal: false
                            }).then(() => {
                                window.location.reload();
                            })
                        } else {
                            this.$message({
                                message: '提交失败',
                                type: 'error'
                            });
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        this.$message({
                            message: '操作失败' + (err.data ? '，' + err.data : ''),
                            type: 'error'
                        });
                    })
            },

            // 显示放弃弹层
            reject (data) {
                this.rejectInfo.id = data.id;
                this.rejectDialog = true;
            },

            // 取消放弃
            cancelReject () {
                this.rejectInfo = {
                    id: '',
                    reason: '',
                    describe: ''
                }
                this.rejectDialog = false;
            },

            // 确定放弃
            submitReject () {
                if (this.rejectInfo.reason === '') {
                    this.$message({
                        message: '请选择放弃理由',
                        type: 'error'
                    });
                    return;
                }
                if (this.rejectInfo.describe.trim().length > 30 || this.rejectInfo.describe.trim().length === 0) {
                    this.$message({
                        message: '请填写不超过30字的描述',
                        type: 'error'
                    });
                    return;
                }
                Api.reject(this.rejectInfo.id, this.rejectInfo.reason, this.rejectInfo.describe)
                    .then((res) => {
                        console.log(res);
                        if (res.status === 0) {
                            this.rejectDialog = false;
                            this.$alert({
                                title: '提示',
                                message: '放弃成功',
                                showCancelButton: false,
                                closeOnClickModal: false
                            }).then(() => {
                                window.location.reload();
                            })
                        } else {
                            this.$message({
                                message: '提交失败',
                                type: 'error'
                            });
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        this.$message({
                            message: '操作失败' + (err.data ? '，' + err.data : ''),
                            type: 'error'
                        });
                    })
            },

            // 搜索订单
            searchOrder () {
                this.getTableData();
            },

            // 导出订单
            exportExcel () {
                let params = {
                    orderState: this.orderState,
                    id: this.form.id,
                    customerPhone: this.form.customerPhone,
                    productNo: this.form.productNo,
                    productName: this.form.productName,
                    orderRefundStatus: -1
                }
                Api.downloadOrder(params);
            },

            // 切换页码
            currentChangeFunc (ev) {
                this.currentPage = ev.current;
                this.getTableData();
            }
        },
        created () {
            this.getTableData();
            this.getExpressInfo();
        }
    }
</script>




// WEBPACK FOOTER //
// Main.vue?0c062ad6